import { put, call } from 'redux-saga/effects';
import { Types } from './actions';
import ProceduresRepository from '../../../repositories/ProceduresRepository';
import ProceduresDataRepository from '../../../../data/repositories/ProceduresDataRepository';
import { RegisterEmployabilityCharterRequest } from '@/domain/entities/procedures/RegisterEmployabilityCharterRequest';
import XCheckpointManager from '@/core/managers/xcheckpointManager';

export default function* execute(action: any): any {
  try {
    const request: RegisterEmployabilityCharterRequest = action;
    yield put({ type: Types.REGISTER_EMPLOYABILITY_CHARTER_REQUEST });

    const registerChangeRepository: ProceduresRepository =
      new ProceduresDataRepository();

    XCheckpointManager.registerStart('Carta de empleabilidad - Registro');
    const result = yield call(
      registerChangeRepository.registerEmployabilityCharter,
      request
    );
    XCheckpointManager.registerEnd('Carta de empleabilidad - Registro');
    yield put({
      type: Types.REGISTER_EMPLOYABILITY_CHARTER_SUCCESS,
      data: result.requestId
    });
  } catch (error) {
    yield put({
      type: Types.REGISTER_EMPLOYABILITY_CHARTER_FAILURE,
      error:
        'Ocurrió un error al momento de registrar los datos del trámite solicitado.'
    });
  }
}
